import { memo } from 'react';
import { Button } from '@bridebook/aura';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';
import { useTranslation } from 'next-i18next';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import Link from 'next/link';

interface IProps {
  bannerImage?: 'start' | 'mid';
  title?: string;
  description?: string;
  btnText?: string;
  url?: string;
}

const CTABanner1 = ({ bannerImage = 'mid', title, description, btnText, url }: IProps) => {
  const { t } = useTranslation('articles');

  return (
    <div className="overflow-hidden rounded-xl">
      <div className="flex h-[148px] flex-col items-center bg-indigo-crush-10">
        <img
          height={148}
          width={175}
          alt="cta-banner-image"
          src={`${IMAGES_BASE_URL}/assets/article/cta-banner-${bannerImage}.png`}
        />
      </div>
      <div className="flex flex-col rounded-b-xl border border-t-0 border-space-15 p-4 text-sm text-space">
        <div className="mb-3 font-semibold">{title ?? t('ctaBanner1.title')}</div>
        <div className="mb-3">{description ?? t('ctaBanner1.description')}</div>
        <Button asChild className="w-full !text-white" size="sm">
          {url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {btnText ?? t('ctaBanner1.btn')}
            </a>
          ) : (
            <Link href={UrlHelper.signup}>{btnText ?? t('ctaBanner1.btn')}</Link>
          )}
        </Button>
      </div>
    </div>
  );
};

export default memo(CTABanner1);
